import React from 'react';

const Empty = function Empty() {
  return (
    <span />
  );
};

export default Empty;
